import request from '@/utils/request'
import APIS from '@/permissions/index'

export function queryBase (params) {
  return request({
    ...APIS['@baseInfo/Query_Base'],
    params
  })
}

export function updateBase (data) {
  return request({
    ...APIS['@baseInfo/Update_Base'],
    data
  })
}

export function deleteBase (params) {
  return request({
    ...APIS['@baseInfo/Delete_Base'],
    params
  })
}

export function queryChangeRecords (params) {
  return request({
    ...APIS['@baseInfo/Query_ChangeRecords'],
    params
  })
}

export function exportBases (params) {
  const headers = {
    'Content-Type': 'application/octet-stream'
  }
  const responseType = 'arraybuffer'
  return request({
    ...APIS['@baseInfo/Export_Bases'],
    params,
    headers,
    responseType
  })
}

export function addBase (data) {
  return request({
    ...APIS['@baseInfo/Add_Base'],
    data
  })
}
